var pagination = {
	backwardText: "vorige pagina",
	forwardText: "volgende pagina",
	pageRangeText: "Pagina {current} van {total}",
	itemsPerPageText: "Items per pagina",
	itemRangeText: "{start}-{end} van {total} items",
	pageNumberText: "huidige pagina"
};
var searchPlaceholder = "Zoeken...";
var nlTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { nlTranslations as default, pagination, searchPlaceholder };
